<template>
    <!-- 场景功能介绍 -->
    <section>
        <!-- 顶部背景图 -->
        <div class="solution-top">
            <p>产品及场景</p>
            <span>立足“存、查、验、享”四大核心能力，赋能航贸、司法、气象等应用场景。</span>
        </div>
        <div class="feature solution">
            <h2 class="text-center">产品功能介绍</h2>
            <div class="feature-ul">
                <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }" style="margin-right: 6%;">
                    <dl class="dl1">
                        <dt><img src="@/assets/img/feature/icon1.png" width="140" /></dt>
                        <h1>安全存储</h1>
                        <dd>
                            <p>用户可以将电子数据例如单证类数据上链存证，确保数据的原始性和不可篡改性。</p>
                        </dd>
                    </dl>
                </el-card>
                <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }">
                    <dl class="dl2">
                        <dt><img src="@/assets/img/feature/icon2.png" width="140" /></dt>
                        <h1>全流程溯源</h1>
                        <dd>
                            <p>支持用户进行链上数据查询，通过数据溯源、数据比对确保数据准确性和完整性。</p>
                        </dd>
                    </dl>
                </el-card>
                <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }" style="margin-right: 6%;">
                    <dl class="dl3">
                        <dt><img src="@/assets/img/feature/icon3.png" width="140" /></dt>
                        <h1>防伪验真</h1>
                        <dd>
                            <p>针对已存证成功的电子数据信息，支持进行一致性对比并输出核验结果。</p>
                        </dd>
                    </dl>
                </el-card>
                <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }">
                    <dl class="dl4">
                        <dt><img src="@/assets/img/feature/icon4.png" width="140" /></dt>
                        <h1>可信共享</h1>
                        <dd>
                            <p>支持存证数据可信流通、共享和开发利用，提高数据价值和应用范围。</p>
                        </dd>
                    </dl>
                </el-card>
            </div>
        </div>
        <!-- 应用场景介绍 -->
        <div class="layoutContent applicationScenarios">
            <div class="container">
                <h1>应用场景介绍</h1>
                <ul>
                    <li v-for="(item, index) in list" :key="item.id">
                        <div>
                            <p>{{ item.title }}</p>
                            <span>{{ item.con }}</span>
                        </div>
                        <img :src="require(`@/assets/img/feature/img${index + 1}.png`)" width="48%" />
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            list: [
                {
                    title: '航贸场景',
                    con: '支持电子提单、电子信用证、无纸化放货等数字化流程，加速数据交换和共享，提高业务协同效率，促进航运贸易的数字化转型，助力优化跨境贸易的营商环境。'
                },
                {
                    title: '司法仲裁',
                    con: '北宸可信数据服务中心的高效存证能力和便捷的查询功能，通过确保电子送达文书的真实性，提升司法文书的权威性，使得证据的使用变得更加高效和便捷，显著提升案件处理速度，广泛应用于法院领域、跨部门司法协同等场景。'
                },
                {
                    title: '气象场景',
                    con: '北宸可信数据服务中心将气象数据纳入可信流通体系中，实现覆盖数据全过程的接入可信、存储可信、加工可信、流通可信，通过与金融、农业等跨行业数据进行深度融合、产品加工，形成气象数据的价值与信任双重传递，有效支撑气象多元数据要素可信流通。'
                }
            ]
        }
    }
}
</script>

<style lang="less">
@import "../../style/feature.less";
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.solution {
    background: url(../../assets/img/feature/bg-con.jpg) no-repeat 0 center;
    background-size: 100% 100%;
}

.solution-top {
    height: 320px;
    background: url(../../assets/us/us-bg.jpg) no-repeat 0 center;
    background-size: 100% 100%;
    padding: 80px 10px 20px 270px;

    p {
        font-size: 34px;
        color: #fff;
        margin-bottom: 10px;
    }

    span {
        font-size: 16px;
        color: #fff;
    }
}

.feature {
    padding: 50px 0 60px;

    .feature-ul {
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;

        .el-card {
            flex: 0 0 45%;
            margin-bottom: 6%;
        }
    }

    dl {
        height: 100%;
        padding: 0 0 0 22px;
        height: 330px;

        h1 {
            margin-bottom: 15px;
        }

    }

    .dl1 {
        background: url("../../assets/img/feature/d1.png") no-repeat 0 center;
        background-size: 100% 100%;
    }

    .dl2 {
        background: url("../../assets/img/feature/d2.png") no-repeat 0 center;
        background-size: 100% 100%;
    }

    .dl3 {
        background: url("../../assets/img/feature/d3.png") no-repeat 0 center;
        background-size: 100% 100%;
    }

    .dl4 {
        background: url("../../assets/img/feature/d4.png") no-repeat 0 center;
        background-size: 100% 100%;
    }

    dt {
        color: #009ef6;
        font-size: 22px;
        margin-bottom: 28px;
    }

    dd {
        width: 11em;
        color: #000;
        font-size: 14px;
        line-height: 26px;
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

    }

    >h2 {
        font-size: 30px;
        color: #000000;
        font-weight: 500;
        letter-spacing: 5px;
    }
}

.applicationScenarios {
    background-color: #3375ef;
    color: #fff;
    padding: 50px 0 60px;

    &>div {
        padding: 0 80px;
    }

    h1 {
        font-size: 28px;
        letter-spacing: 8px;
        margin-bottom: 20px;
        text-align: center;
    }

    ul {
        li {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            div {
                flex: 0 0 48%;
                padding: 40px 0 0;

                p {
                    font-size: 22px;
                    margin-bottom: 20px;
                }

                span {
                    font-size: 16px;
                    line-height: 2;
                }
            }
        }

        li:nth-child(1) {
            div {
                background: url("../../assets/img/feature/left1.png") no-repeat 0 center;
                background-size: 100% 100%;
            }
        }

        li:nth-child(2) {
            div {
                background: url("../../assets/img/feature/left2.png") no-repeat 0 center;
                background-size: 100% 100%;
            }
        }

        li:nth-child(3) {
            div {
                background: url("../../assets/img/feature/left3.png") no-repeat 0 center;
                background-size: 100% 100%;
            }
        }
    }
}

@media (max-width: 768px) {
    .solution {
        padding: 30px 0 80px 0;

        dd {
            width: 96%;

            .block {
                width: 5px;
                height: 2px;
            }
        }

        h3 {
            text-align: left;
            padding: 0 20px;
            font-size: 20px;
        }
    }


    .product-box {
        width: 80%;
        float: none;
        margin: 0 auto 20px;
    }

    .el-row--flex {
        display: block;
    }

    .solution-box {
        width: 80%;
        float: none;
        margin: 0 auto 20px;

        dl {
            padding: 30px;
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/views/feature/index.vue